<template>
  <article
    class="story-thumbnail"
    :class="[{ 'story-thumbnail--viewed': viewed }]"
    :style="`background-image: url('${img}'); background-color: ${bgColor}`"
    @click="$emit('click')"
  >
    <h3 class="story-thumbnail__title" :style="`color: ${textColor};`">{{ title }}</h3>
  </article>
</template>

<script>
export default {
  name: 'story-thumbnail',
  props: {
    title: {
      type: String,
      required: true,
    },
    textColor: {
      type: String,
      default: '#f8f6f6',
    },
    bgColor: {
      type: String,
      default: '#f8f6f6',
    },
    img: {
      type: String,
      required: true,
    },
    viewed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.story-thumbnail
  --outline-color: #00b0bd

  border-radius: 10px
  display: flex
  align-items: end
  height: 86px
  cursor: pointer
  outline: 2px solid var(--outline-color)
  outline-offset: 4px
  background-size: cover
  background-position: center center
  background-repeat: no-repeat
  transition: transform .2s cubic-bezier(.17, 0, .63, 1)
  will-change: transform

  &:hover
    transform: translateY(-8px)

  &__title
    font-size: 13px
    font-weight: bold
    padding: 12px
    user-select: none
    -webkit-user-select: none
    -ms-user-select: none

    @media screen and (min-width: $tablet-header)
      font-size: 16px

    @media screen and (min-width: 1382px)
      font-size: 22.4px

  &--viewed
    --outline-color: #c5c5c5
</style>



// WEBPACK FOOTER //
// src/templates/components/base/stories/StoryThumbnail.vue